<template>
  <input-text-modal
    title="Passphrase"
    v-model="passphrase"
    :error="error"
    errorMessage="Error: the passphrase have to have at least 12 characters"
    v-on:ok="onOk()"
    v-on:cancel="$emit('cancel')"/>
</template>

<script>
import InputTextModal from '@/components/shared/dialogs/InputTextModal';
export default {
  name: 'NightscoutPassphraseModal',
  components: {
    InputTextModal
  },
  data () {
    return {
      passphrase: '',
      error: false
    };
  },
  methods: {
    onOk () {
      if (this.passphrase.length < 12) {
        this.error = true;
      } else {
        this.error = false;
        this.$emit('ok', this.passphrase);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../../stylesheets/variables.scss";
</style>



// WEBPACK FOOTER //
// src/brand/health/components/nightscout/NightscoutPassphraseModal.vue